export default __webpack_public_path__ + "static/brand_01-980c386638c3bdc56f8f914c7e9af394.png";